import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. They are
 * deliberately kept out of the slice's reducers: they trigger side effects, not
 * state transitions (the saga owns the `*Started/*Succeeded/*Failed` ones).
 */

/**
 * Parse the selected file. The `File` payload is deliberately non-serialisable
 * (listed in the store's `serializableCheck.ignoredActions`); it is consumed by
 * the saga for the upload call and never enters the state; only its name does.
 */
export const parseRequested = createAction<File>('fileImport/parseRequested');

/** Dry-run the mapped rows against the database (Map Columns → Analyze). */
export const analyzeRequested = createAction('fileImport/analyzeRequested');

/** Run the import (Analyze → Results). */
export const importRequested = createAction('fileImport/importRequested');
